import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet, useMatchRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Toaster } from 'sonner';
import { Footer } from '../components/Footer/Footer';
import { FundingTracker } from '../components/FundingTracker/FundingTracker';
import { Header } from '../components/Header/Header';
import { LiquidationTracker } from '../components/LiquidationTracker/LiquidationTracker';
import { PricesSub } from '../components/PricesSub/PricesSub';
import { RootModals } from '../components/RootModals/RootModals';
import { SubaccountTracker } from '../components/SubaccountTracker/SubaccountTracker';
import { TanStackRouterDevtools } from '../components/TanstackRouterDevtools/TanStackRouterDevtools';
import { UserTracker } from '../components/UserTracker/UserTracker';
import { useFillsSub } from '../hooks/useFillsSub';
import { useNetworkAndWakeDetection } from '../hooks/useNetworkAndWakeDetection';
import { useOrdersSub } from '../hooks/useOrdersSub';
import { useTailwindBreakpoint } from '../hooks/useTailwindBreakpoint';
import { useTransferSub } from '../hooks/useTransferSub';
import { cn } from '../lib/classNameHelpers';

const RootComponent = () => {
  useFillsSub();
  useOrdersSub();
  useTransferSub();
  useNetworkAndWakeDetection();

  const isSm = useTailwindBreakpoint('sm');
  const isMd = useTailwindBreakpoint('md');

  const matchRoute = useMatchRoute();
  const isTradePage = matchRoute({ to: '/trade', fuzzy: true });

  return (
    <>
      <div
        className={cn(
          'flex min-h-dvh flex-col max-lg:bg-backgroundPrimary lg:gap-1 lg:p-1',
          // Accomodate for PersistentBottomBar in TradePage
          isTradePage && 'max-lg:pb-16'
        )}
      >
        <Header />
        <div className="flex flex-1 flex-col">
          <Outlet />
        </div>
        {isMd && <Footer />}
      </div>
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
      <RootModals />
      <Toaster position={isSm ? 'bottom-right' : 'top-right'} />
      <PricesSub />
      <UserTracker />
      <FundingTracker />
      <SubaccountTracker />
      <LiquidationTracker />
      {/* <WagmiModalCloser /> */}
    </>
  );
};

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
});
